import FieldString from "../../../generic/string/string"
import FieldConfig from "../../../proto/field-config"
import Project from "../../../../model2/project/project"
import FieldProjectName_Editable from "./render/editable/editable"
import {FIELD_CONDITIONS_NAME} from "../../../conditions/string"
import {FieldAccess} from "../../../const"

export default class FieldProjectName extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Project Name";

        this.conditionTypes = FIELD_CONDITIONS_NAME

        this.renderComponents.editable = FieldProjectName_Editable
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeProjectName
    }

    access(model: any) {
        if (model) {
            return gd.ac.check.project.fullAccess(model.id) ? FieldAccess.WRITE : FieldAccess.READ
        }

        return super.access(model)
    }
}
